import React, { ReactNode } from 'react';

export default function CellIconWrapper({ children }: { children: ReactNode }) {
  return <div className="h-full inline flex items-center justify-start">{children}</div>;
}
